import * as React from 'react'

import { makeObservable, observable, runInAction } from 'mobx'
import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import WeatherWeeklyWidget from '~/client/src/desktop/components/WeatherWeeklyWidget/WeatherWeeklyWidget'
import {
  temperatureUnits,
  windSpeedUnits,
} from '~/client/src/shared/enums/WeatherUnits'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import WeatherForecastInfo from '~/client/src/shared/models/WeatherInfo'
import WeatherForecastsStore from '~/client/src/shared/stores/domain/WeatherForecasts.store'
import InitialState from '~/client/src/shared/stores/InitialState'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import WeatherDayWidget from './WeatherDayWidget'

import './DetailedWeatherWidget.scss'

interface IProps {
  weatherForecastsStore?: WeatherForecastsStore
  projectDateStore?: ProjectDateStore
  state?: InitialState
}

enum ForecastPeriod {
  Today,
  Tomorrow,
  Week,
}

const ICON_SIZE = 32

const PRESET_BUTTONS = [
  {
    key: 'today',
    shift: ForecastPeriod.Today,
  },
  {
    key: 'tomorrow',
    shift: ForecastPeriod.Tomorrow,
  },
  {
    key: 'fiveDayForecast',
    shift: ForecastPeriod.Week,
  },
]

@inject('weatherForecastsStore', 'state', 'projectDateStore')
@observer
export default class DetailedWeatherWidget extends React.Component<IProps> {
  @observable private currentView: number = ForecastPeriod.Today

  public constructor(props: IProps) {
    super(props)

    makeObservable(this)
  }

  public render() {
    const { weatherForecastsStore, state, projectDateStore } = this.props
    const temperatureUnit = temperatureUnits(weatherForecastsStore.weatherUnits)
    const windSpeedUnit = windSpeedUnits(weatherForecastsStore.weatherUnits)
    const projectAddress = state.projectAddress

    let forecasts: WeatherForecastInfo[], startDate: Date
    switch (this.currentView) {
      case ForecastPeriod.Today:
        forecasts = [weatherForecastsStore.todayForecast]
        startDate = new Date()
        break
      case ForecastPeriod.Tomorrow:
        forecasts = [weatherForecastsStore.tomorrowForecast]
        startDate = projectDateStore.addDays(new Date(), 1)
        break
      case ForecastPeriod.Week:
        forecasts = weatherForecastsStore.weatherByDaysList
        startDate = new Date(Date.now())
        break
    }

    if (!forecasts?.[0] || !startDate) {
      return null
    }

    return (
      <div className="col pt16 px16 pb8 gap-8 mw520">
        <div className="row full-width full-height x-start relative generic-tabs-container no-select">
          {PRESET_BUTTONS.map(({ key, shift }) => (
            <div
              key={key}
              className="inline-block h50 vertical-align-middle bb-light-grey"
            >
              <div
                className={classList({
                  'row x-center y-center pointer no-flex tab-item': true,
                  active: shift === this.currentView,
                })}
                onClick={this.handleShiftForecast(shift)}
              >
                {Localization.translator[key]}
              </div>
            </div>
          ))}
        </div>

        {this.currentView === ForecastPeriod.Week ? (
          <WeatherWeeklyWidget
            startDate={startDate}
            iconSize={ICON_SIZE}
            forecasts={forecasts}
            projectAddress={projectAddress}
            temperatureUnit={temperatureUnit}
          />
        ) : (
          <WeatherDayWidget
            startDate={startDate}
            todayForecast={forecasts[0]}
            temperatureUnit={temperatureUnit}
            windSpeedUnit={windSpeedUnit}
            projectAddress={projectAddress}
          />
        )}
      </div>
    )
  }

  private handleShiftForecast = (shift: number) => () => {
    runInAction(() => {
      this.currentView = shift
    })
  }
}
